import { useContext } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { PaginationContexts } from '../../App';
import { fetchVideos, paginate } from '../../features/videos/videosSlice'
export default function Pagination() {
  const dispatch = useDispatch()
  const { totalCount, pageCount, limit } = useSelector((state) => state?.videos)
  const { tags, search } = useSelector((state) => state.filter)
  const { selected, setSelected } = useContext(PaginationContexts)
  const handleSelected = (page, limit, i) => {
    setSelected(i)
    dispatch(paginate({ page, limit }))
    dispatch(fetchVideos({ tags, search, page, limit }))
  }
  return (
    <section className="pt-12">
      <div className="max-w-7xl mx-auto px-5 py-6 lg:px-0 flex gap-2 justify-end">
        {totalCount > 0 &&
          Array(pageCount)
            .fill({ id: Date.now() })
            .map((x, i, arr) => {
              return (
                <div
                  className={`text-white px-4 py-1 rounded-full cursor-pointer ${
                    selected === i ? 'bg-blue-600' : 'bg-gray-400'
                  }`}
                  key={i}
                  onClick={() => handleSelected(i + 1, limit, i)}
                >
                  {i + 1}
                </div>
              )
            })}
      </div>
    </section>
  )
}
